import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Meal qty columns stored from mess-inventory ag-grid (Breakfast / Lunch / Snacks / Dinner). */
export interface StoredMealQtyRow {
  itemId: number | string;
  bfQty: number;
  lunchQty: number;
  snacksQty: number;
  DinnerQty: number;
}

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
 private readonly mealQtySubject = new BehaviorSubject<StoredMealQtyRow[]>([]);

  /** Observable of entered Breakfast / Lunch / Snacks / Dinner qty rows. */
  readonly mealQty$ = this.mealQtySubject.asObservable();

  constructor() { }

  getMealQtySnapshot(): StoredMealQtyRow[] {
    return this.mealQtySubject.getValue();
  }

  /** Upsert one item's meal qty values from grid entry. */
  setMealQtyForItem(row: Partial<StoredMealQtyRow> & { itemId: number | string }): void {
    const itemId = row.itemId;
    if (itemId == null || itemId === '') {
      return;
    }
    const next: StoredMealQtyRow = {
      itemId,
      bfQty: Number(row.bfQty ?? 0),
      lunchQty: Number(row.lunchQty ?? 0),
      snacksQty: Number(row.snacksQty ?? 0),
      DinnerQty: Number(row.DinnerQty ?? 0),
    };
    const list = [...this.mealQtySubject.getValue()];
    const idx = list.findIndex((r) => String(r.itemId) === String(itemId));
    if (idx >= 0) {
      list[idx] = next;
    } else {
      list.push(next);
    }
    this.mealQtySubject.next(list);
  }

  /** Replace entire meal-qty store (e.g. sync from all grid rows). */
  setMealQtyRows(rows: StoredMealQtyRow[]): void {
    this.mealQtySubject.next(Array.isArray(rows) ? [...rows] : []);
  }

  /** Clear BehaviorSubject (e.g. on Daysheet Submit / Total Summary sbd__btn). */
  clearMealQty(): void {
    this.mealQtySubject.next([]);
  }
}
